import { render, staticRenderFns } from "./MyDocuments.vue?vue&type=template&id=25203db9&scoped=true&"
import script from "./MyDocuments.vue?vue&type=script&lang=js&"
export * from "./MyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./MyDocuments.vue?vue&type=style&index=0&id=25203db9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25203db9",
  null
  
)

export default component.exports